// FETCH ALL PROPERTIES FROM FABRIC_INWARD DETAILS
export const FETCH_FABRIC_INWARD_DETAILS_REQUEST = 'FETCH_FABRIC_INWARD_DETAILS_REQUEST';
export const FETCH_FABRIC_INWARD_DETAILS_SUCCESS = 'FETCH_FABRIC_INWARD_DETAILS_SUCCESS';
export const FETCH_FABRIC_INWARD_DETAILS_FAILURE = 'FETCH_FABRIC_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM FABRIC_INWARD DETAILS BY ID
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE';

export const FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_REQUEST = 'FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_REQUEST';
export const FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_SUCCESS = 'FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_SUCCESS';
export const FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_FAILURE = 'FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_FAILURE';

export const FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_FAILURE';

// CREATE PROPERTIES FOR FABRIC_INWARD DETAILS
export const CREATE_FABRIC_INWARD_DETAILS_REQUEST = 'CREATE_FABRIC_INWARD_DETAILS_REQUEST';
export const CREATE_FABRIC_INWARD_DETAILS_SUCCESS = 'CREATE_FABRIC_INWARD_DETAILS_SUCCESS';
export const CREATE_FABRIC_INWARD_DETAILS_FAILURE = 'CREATE_FABRIC_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_FABRIC_INWARD_DETAILS = 'CREATE_USER_FORM_FABRIC_INWARD_DETAILS';

// UPDATE PROPERTIES FOR FABRIC_INWARD DETAILS
export const UPDATE_FABRIC_INWARD_DETAILS_REQUEST = 'UPDATE_FABRIC_INWARD_DETAILS_REQUEST';
export const UPDATE_FABRIC_INWARD_DETAILS_SUCCESS = 'UPDATE_FABRIC_INWARD_DETAILS_SUCCESS';
export const UPDATE_FABRIC_INWARD_DETAILS_FAILURE = 'UPDATE_FABRIC_INWARD_DETAILS_FAILURE';

// FETCH SINGLE FABRIC_INWARD_DETAILS
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR FABRIC_INWARD DETAILS
export const DELETE_FABRIC_INWARD_DETAILS_REQUEST = 'DELETE_FABRIC_INWARD_DETAILS_REQUEST';
export const DELETE_FABRIC_INWARD_DETAILS_SUCCESS = 'DELETE_FABRIC_INWARD_DETAILS_SUCCESS';
export const DELETE_FABRIC_INWARD_DETAILS_FAILURE = 'DELETE_FABRIC_INWARD_DETAILS_FAILURE';

// USERFORM RESET

export const FABRIC_INWARD_DETAILS_USERFORM_RESET = 'FABRIC_INWARD_DETAILS_USERFORM_RESET';

export const FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED = 'FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED';
